import React, { Component } from 'react';

class ResumeItem extends Component {
  render() {
    const { title, role, location, director, image, link } = this.props;
    return (
      <article className="resume-item">
        <div className="image-container">
          {image && (
            <a href={link} target="_blank" rel="noopener noreferrer">
              <img src={image} alt={`${title} Playbill`} loading="lazy" />
            </a>
          )}
        </div>
        <div className="resume-text">
          <div>
            <h3>{title}</h3>
          </div>
          <div>
            <div className="role">{role}</div>
            {location && <div className="resume-location">{location}</div>}
            {director && <div className="resume-director">{director}</div>}
          </div>
        </div>
      </article>
    );
  }
}

export default ResumeItem;
